export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/down-arrow.ac922698.svg","height":9,"width":19,"blurWidth":0,"blurHeight":0};